<template>
    <div class="section section--discount">
        <div class="container mb-5">
            <h3 class="title is-4 has-text-grey mb-1">
                {{ $t('discount.header') }}
            </h3>
        </div>
        <form @submit.prevent.stop="validateDiscount()">
            <div class="columns is-multiline">
                <div class="column is-one-third-tablet">
                    <div class="field has-addons">
                        <div class="control is-expanded">
                            <b-input
                                v-model="discountCode"
                                type="text"
                                maxlength="30"
                                :has-counter="false"
                                :disabled="isLoading"
                                :placeholder="$t('discount.inputLabels.discountCode')"
                            />
                        </div>
                        <div class="control">
                            <b-button
                                class="button is-primary-dark validate-button"
                                native-type="submit"
                                :disabled="discountCode.length < 2"
                                :loading="isLoading"
                            >
                                {{ $t('discount.actionLabels.validateCode') }}
                            </b-button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
        <div v-if="discount.code && !modalIsOpen" class="section--used-vouchers">
            <h4 class="title has-text-grey">
                {{ $t('discount.usedVoucher')}}
            </h4>
            <div class="voucher">
                {{ this.discount.value}} {{ this.discount.type === 'absolute' ? '€' : '%'}} {{ this.discount.name }}
                <span class="voucher-code">
                    ( {{ this.discount.code }} )
                </span>
                <div @click="discardDiscount" class="voucher-delete" role="button">
                        {{ $t('discount.actionLabels.removeDiscount') }}
                </div>
            </div>
        </div>
        <b-modal v-model="modalIsOpen" width="600px">
            <template #default="props">
                <voucher-modal />
            </template>
        </b-modal>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VoucherModal from './VoucherModal';
import { sendGenericErrorMessage } from '../../../utilities/send-generic-error-message';

export default {
    name: 'ValidateVoucherForm',
    components: { VoucherModal },
    data() {
        return {
            discountCode: '',
            isLoading: false,
            modalIsOpen: false,
        };
    },
    methods: {
        async validateDiscount() {
            this.isLoading = true;

            await this.$store
                .dispatch('validateDiscountCode', { code: this.discountCode, userId: this.userAccountDetails.userId || null })
                .then(() => {
                    this.modalIsOpen = true;
                })
                .catch((e) => {
                    if ([404, 409].indexOf(e.response.status != -1)) {

                        let title = this.$t('discount.voucherIsNotValid')
                        let message = this.$t('discount.couldNotBeValidated')

                        const errorKey = e.response.data?.key;

                        if (errorKey === 'loginRequired') {
                            title = this.$t('discount.loginRequired');
                            message = this.$t('discount.voucherNeedsLogin')
                        }

                        if (errorKey === 'maxUsage') {
                            message = this.$t('discount.voucherMaxUsageReached');
                        }

                        this.$buefy.dialog.alert({
                            title,
                            message,
                            type: 'is-info',
                            hasIcon: false,
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            confirmText: this.$t(
                                'discount.actionLabels.tryAgain'
                            ),
                            ariaModal: true,
                        });

                    }
                    else {
                        sendGenericErrorMessage();
                    }
 
                });
            this.isLoading = false;
        },
        ...mapActions(['discardDiscount']),
    },
    computed: {
        ...mapGetters(['discount', 'userAccountDetails']),
    },
    mounted() {
        if (this.discount) {
            this.discountCode = this.discount.code || '';
        }
    },
};
</script>

<style lang="scss">
.section--discount {
    .field {
                background: none;
                font-size: 0.9rem;
                max-width: 30rem;
                input {
                    height: auto;
                    padding: 0.5rem 0.8rem;
                    &::placeholder {
                        font-size: 0.8rem;
                        text-transform: uppercase;
                        color: $dark;
                    }
                }
                .button {
                    font-family: $fontfamily-bold;
                    text-transform: uppercase;
                    font-size: 0.9rem;
                    height: 100%;
                    padding-left: 1.5rem;
                    padding-right: 1.5rem;

                    .svg-container {
                        transform: translateY(-10%);
                    }
                }
            }

    .section--used-vouchers {
        margin-top: 2em;
        .title {
            // font-family: $fontfamily-medium;
            font-size: 1.2rem;
            // text-transform: uppercase;
        }
        .voucher {
            display:flex;
            flex-direction: row;
            align-items: center;
            gap:0.75em;
            font-size: 1.375rem;
            color: $grey-dark;
            .voucher-code {
                color: $grey;
            }
            .voucher-delete {
                cursor: pointer;
                font-size:0.8rem;

                &:hover {
                    color: $primary-dark;
                }
            }

        }
    }
    .validate-button {
        height: 100%;
    }
}
</style>
